import React, { useMemo } from 'react';
import { Box, List, Text } from '@common-fe/common-fe';

export interface EmailTemplateField {
  key?: string;
  title?: string;
  type?: string;
  value?: string;
}

export interface EmailTemplateListItem {
  id: string;
  fields: EmailTemplateField[];
}

const FIELD_KEYS = {
  notificationName: 'notificationName',
  templateName: 'templateName',
  category: 'category',
  destination: 'destination',
};

const EmailTemplateConfigurationListItem: React.FC<{
  id: string;
  fields: EmailTemplateField[];
  onEdit: (id: string) => void;
}> = ({ id, fields, onEdit }) => {
  const fieldMap = useMemo(() => {
    return fields.reduce<Record<string, EmailTemplateField>>((acc, field) => {
      if (field.key) acc[field.key] = field;
      return acc;
    }, {});
  }, [fields]);

  return (
    <List.Item testId="email-template-list_item">
      <Box style={{ flex: 1.1 }}>
        <Text weight="bold" truncate title={fieldMap[FIELD_KEYS.notificationName]?.title || ''}>
          {fieldMap[FIELD_KEYS.notificationName]?.title || ''}
        </Text>
      </Box>
      <Box style={{ flex: 1.2 }}>
        <Text weight="normal" truncate title={fieldMap[FIELD_KEYS.templateName]?.title || ''}>
          {fieldMap[FIELD_KEYS.templateName]?.title || ''}
        </Text>
      </Box>
      <Box style={{ flex: 0.8 }}>
        <Text weight="normal" truncate title={fieldMap[FIELD_KEYS.category]?.title || ''}>
          {fieldMap[FIELD_KEYS.category]?.title || ''}
        </Text>
      </Box>
      <Box style={{ flex: 0.8 }}>
        <Text weight="normal" truncate title={fieldMap[FIELD_KEYS.destination]?.title || ''}>
          {fieldMap[FIELD_KEYS.destination]?.title || ''}
        </Text>
      </Box>
      <List.Item.Options>
        <List.Item.Options.Item onClick={() => onEdit(id)}>Edit</List.Item.Options.Item>
      </List.Item.Options>
    </List.Item>
  );
};

export default EmailTemplateConfigurationListItem;
